"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _glyph = _interopRequireDefault(require("../../components/cta/glyph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Text = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "login-modal__Text",
  componentId: "sc-eb39am-0"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
var LinkArrow = (0, _styledComponents["default"])(_components.NavCaretRight).withConfig({
  displayName: "login-modal__LinkArrow",
  componentId: "sc-eb39am-1"
})(["height:24px;vertical-align:middle;width:24px;"]);
var propTypes = {
  /** onClick handler for account settings */
  accountOnClick: _propTypes.func,

  /** onClick handler for navigating to a create account page */
  createAccountOnClick: _propTypes.func,

  /** Whether the user is logged in/out, used to determine which text to show */
  isLoggedIn: _propTypes.bool.isRequired,

  /** log in string - user instruction */
  logIn: _propTypes.string.isRequired,

  /** Create a QC account string - user instruction */
  logInQCAccount: _propTypes.string.isRequired,

  /** log out string - user instruction */
  logOut: _propTypes.string.isRequired,

  /** onClick handler for navigating to a login page */
  loginOnClick: _propTypes.func,

  /** onClick handler for logging user out */
  logoutOnClick: _propTypes.func,

  /** User email string displayed when logged in */
  userEmail: _propTypes.string,

  /** User name string (e.g. "Michael Park") displayed when logged in */
  userFullName: _propTypes.string
};
var loginModalStyles = {
  alignItems: "flex-start",
  backgroundColor: "background",
  borderRadius: 8,
  boxShadow: ["0 2px 10px 0 rgba(74,90,117,0.08)", "0 20px 20px -12px rgba(74,90,117,0.24)"],
  flexDirection: "column",
  justifyContent: "center"
};
var loggedInStyles = {
  flexWrap: "wrap",
  justifyContent: "flex-start",
  textAlign: "left",
  width: 1
};
var userNameStyles = {
  color: "gray-dark",
  fontSize: 5,
  fontWeight: 2,
  letterSpacing: "0.3px",
  lineHeight: 3,
  mb: 1,
  width: 1
};
var userEmailStyles = {
  color: "body-grey",
  fontSize: 3,
  letterSpacing: "0.5px",
  lineHeight: 3,
  width: 1
};
var loginStyles = {
  color: "body-grey",
  fontSize: 3,
  letterSpacing: "0.5px",
  lineHeight: 2,
  mb: 3,
  px: "3px",
  width: 1
};
var loginFlexStyles = {
  flexDirection: "column",
  flexWrap: "wrap",
  justifyContent: "center",
  width: 1
};
var ctaBoxStyles = {
  borderTop: "solid 2px",
  borderTopColor: "gray-light",
  width: 1
};
var ctaStyles = {
  fontSize: 3,
  fontWeight: 1,
  justifyContent: "flex-start",
  letterSpacing: "0.5px",
  lineHeight: 2,
  mb: 0,
  p: 2,
  size: "small",
  version: "link",
  width: 1
};
var loginCtaStyles = {
  mb: 0,
  p: 1,
  size: "small",
  version: "tertiary",
  width: 1
};
var createAccountFlexStyles = {
  alignItems: "center",
  justifyContent: "flex-start",
  mt: 3,
  width: 1
};
var accountPromptStyles = {
  color: "body-grey",
  fontSize: 2,
  letterSpacing: "0.5px",
  lineHeight: 2
};
var createAccountCtaStyles = {
  fontSize: 2,
  version: "link"
};
var buttonGlyphStyles = {
  animateGlyph: true,
  pl: 180
};

var LoginModal = function LoginModal(_ref) {
  var accountOnClick = _ref.accountOnClick,
      createAccountOnClick = _ref.createAccountOnClick,
      isLoggedIn = _ref.isLoggedIn,
      logoutOnClick = _ref.logoutOnClick,
      loginOnClick = _ref.loginOnClick,
      userEmail = _ref.userEmail,
      userFullName = _ref.userFullName,
      logIn = _ref.logIn,
      logOut = _ref.logOut,
      logInQCAccount = _ref.logInQCAccount;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({}, loginModalStyles, {
    p: !isLoggedIn ? 3 : null,
    width: isLoggedIn ? 355 : 300
  }), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({}, loggedInStyles, {
    p: isLoggedIn ? 2 : null
  }), isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, userNameStyles, userFullName), /*#__PURE__*/_react["default"].createElement(Text, userEmailStyles, userEmail)) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, loginStyles, logInQCAccount)), isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, loginFlexStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, ctaBoxStyles, /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({}, ctaStyles, {
    onClick: accountOnClick,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), "Account Settings", /*#__PURE__*/_react["default"].createElement(_glyph["default"], buttonGlyphStyles, /*#__PURE__*/_react["default"].createElement(LinkArrow, null)))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, ctaBoxStyles, /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({}, ctaStyles, {
    lineHeight: 3,
    onClick: logoutOnClick,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), logOut))) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, loginFlexStyles, /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({}, loginCtaStyles, {
    onClick: loginOnClick,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), logIn)), isLoggedIn ? null : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, createAccountFlexStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, accountPromptStyles, "Don't have an account?", /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({}, createAccountCtaStyles, {
    onClick: createAccountOnClick,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }), "Create one"))));
};

LoginModal.propTypes = propTypes;
LoginModal.displayName = "Modules.LoginModal";
var _default = LoginModal;
exports["default"] = _default;